import CreateAccess from './CreateAccess'
import SetupPassword from './SetupPassword'
import SetupWorkspace from './SetupWorkspace'
import SignUp from './SignUp'

const CreateAccessStep = {
  SetupPassword,
  SetupWorkspace,
  SignUp,
}

export { CreateAccessStep }
export default CreateAccess
